import React from "react";
import PropTypes from "prop-types";

const OptionLink = ({
  filterName,
  printOption,
  onChooseOption,
  isSelected,
}) => {
  // Set 'selected' class if option is selected
  const selectedOption = isSelected ? "selected" : "";

  return (
    <a
      className={`tool__option tool__option--link ${selectedOption}`}
      key={printOption.value}
      onClick={onChooseOption.bind(null, filterName, printOption.value)}
    >
      {printOption.value}
    </a>
  );
};

OptionLink.propTypes = {
  filterName: PropTypes.string.isRequired,
  printOption: PropTypes.object.isRequired,
  onChooseOption: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export default OptionLink;
